import { useEffect } from 'react';

/**
 * Порядок задач на поточному екрані (перелік, дошка, «Моя робота»): картка задачі перемикається
 * на сусідню клавішами J/K або ↑/↓, не закриваючись. Екран реєструє видимий порядок; діє останній.
 */
let current: string[] = [];

export function useRegisterTaskNav(ids: string[]) {
  const key = ids.join(',');
  useEffect(() => {
    const list = key ? key.split(',') : [];
    current = list;
    return () => {
      if (current === list) current = [];
    };
  }, [key]);
}

/** Сусідня задача в зареєстрованому порядку (або undefined на краю чи поза переліком). */
export function neighborTask(id: string, dir: 1 | -1): string | undefined {
  const i = current.indexOf(id);
  if (i < 0) return undefined;
  return current[i + dir];
}

/** Подія «фокус перейшов на рядок задачі» — відкрита картка слідує за фокусом. */
export const TASK_FOCUS_EVENT = 'ers:task-focus';

export function announceTaskFocus(id: string) {
  window.dispatchEvent(new CustomEvent<string>(TASK_FOCUS_EVENT, { detail: id }));
}
